const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5555';

export type UserType = 'free' | 'subscriber' | 'admin' | 'investor';

export interface UserProfile {
  uid: string;
  email: string;
  displayName: string | null;
  photoURL: string | null;
  createdAt: string;
  lastSignInTime: string;
  type: UserType[];
  promo: string | null;
}

/**
 * Get user profile including type
 */
export async function getUserProfile(userId: string): Promise<UserProfile> {
  const response = await fetch(`${API_BASE}/api/users/${userId}`);

  if (!response.ok) {
    throw new Error('Failed to fetch user profile');
  }

  return response.json();
}

/**
 * Check if user has a specific type
 */
export function hasUserType(types: UserType[], type: UserType): boolean {
  return types.includes(type);
}

/**
 * Check if user is an investor
 */
export function isInvestor(types: UserType[]): boolean {
  return hasUserType(types, 'investor');
}

/**
 * Initialize subscription for a new user
 * Called immediately after sign-in to ensure user record is created
 * and Telegram notification is sent for new users
 */
export async function initializeUserSubscription(
  userId: string,
  email: string,
  region: string = 'na'
): Promise<void> {
  const response = await fetch(`${API_BASE}/api/subscriptions/${userId}/initialize`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, region }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to initialize subscription');
  }
}
